import { EventEmitter } from 'events';

export { EventEmitter } from 'events';

export const eventBus = new EventEmitter();
